<template>
  <div class="w-100 transition">
    <GenericReport
      title="Relatório de materiais parados"
      :route="route"
      :fields="fields"
      :topFilters="topFilters"
      :sideFilters="sideFilters"
      tipoRelatorio="relatorioProcessos"
    />
  </div>
</template>

<script>
import moment from 'moment';
import GenericReport from '@/components/Table/GenericReport';

export default {
  name: 'relatorioMateriaisParados',
  components: {
    GenericReport,
  },

  data() {
    return {
      route: 'report/materiaisParados',
      fields: [
        {
          key: 'tipoMaterial',
          label: 'Tipo de Material',
        },
        {
          key: 'shownId',
          label: 'ID',
        },
        {
          key: 'descricao',
          label: 'Descrição',
        },
        {
          key: 'dataHora',
          label: 'Data / Hora',
        },
        {
          key: 'usuario',
          label: 'Usuário',
        },
        {
          key: 'motivo',
          label: 'Motivo',
        },
        {
          key: 'observacao',
          label: 'Observação',
        },
      ],
      topFilters: {
        id_unidade: {
          type: 'genericSelect',
          route: 'unidade',
          defaultValue: null,
          firstOption: {
            value: null,
            label: 'Unidade',
          },
        },
        date: {
          type: 'rangeDate',
          defaultInitDate: moment().subtract(7, 'days'),
          defaultEndDate: moment(),
        },
        tipo_manutencao: {
          type: 'genericSelect',
          route: 'tipoManutencao',
          defaultValue: null,
          firstOption: {
            value: null,
            label: 'Tipo de Manutenção',
          },
        },
      },
      sideFilters: {
        id: {
          type: 'input',
          label: 'ID',
        },
        descricao: {
          type: 'input',
          label: 'Descrição',
        },
        id_tipo_material: {
          type: 'genericSelect',
          label: 'Tipo de Material',
          route: 'tipoMaterial',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
$primary-color-50: #209f85;

.paginador {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.transition {
  transition: 0.3s ease-in-out;
}

#report h2 {
  margin-bottom: 30px;
}

#report table {
  background-color: #FFF;
}

#report table thead th {
  color: #7E829F;
  padding-bottom: 50px;
  font-weight: 900;
}

</style>
